<template lang="pug">
b-container#StoreWithdrawalsView(fluid="lg")
  ListWithdrawals(@create-pickup-request="openCreatePickupRequestModal" ref="listWithdrawals")
  AppModal(
      v-model="showCreatePickupRequestModal"
      title="Crear Retiro"
    )
      PickupRequestForm(@submit="onSubmit" @cancel="closeCreatePickupRequestModal")
</template>
<script>
import ListWithdrawals from '../components/withdrawal/ListWithdrawals'
import AppModal from '../components/UI/AppModal.vue'
import PickupRequestForm from '../components/pickupRequests/PickupRequestForm.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    ListWithdrawals,
    AppModal,
    PickupRequestForm
  },
  data() {
    return {
      showCreatePickupRequestModal: false
    }
  },
  methods: {
    openCreatePickupRequestModal() {
      this.showCreatePickupRequestModal = true
    },
    closeCreatePickupRequestModal() {
      this.showCreatePickupRequestModal = false
    },
    async onSubmit(pickupRequest) {
      if (!pickupRequest) return
      const response = await this.createPickupRequest({ data: pickupRequest })
      if (response.status >= 200 && response.status < 300) {
        this.closeCreatePickupRequestModal()
        this.$refs.listWithdrawals?.fetchData()
      } else {
        this.$bvToast.toast(response.data.message, {
          title: 'Error',
          variant: 'danger'
        })
      }
    },
    ...mapActions(['createPickupRequest', 'listDelivery'])
  }
}
</script>
